<div class="dock-dashboard">
  <p-dock [model]="dockItems" position="bottom" >
    <ng-template pTemplate="item" let-item>
      <i [class]="item.icon"></i>
      {{item.label}}
    </ng-template>
  </p-dock>

  <p-toast></p-toast>

</div>
